<template>
  <div>
    <site-form :contractRequirementTypes="contractRequirementTypes" :site="site" />
  </div>
</template>

<script>
import SiteForm from "../../components/sites/site-form";
import sitesApi from "../../api/sites";

var htmlDecode = require("js-htmlencode").htmlDecode;

export default {
  data() {
    return {
      contractRequirementTypes: [],
      site: null
    };
  },

  props: {
    siteId: {
      required: true
    }
  },

  components: {
    "site-form": SiteForm
  },

  created() {
    var that = this;
    sitesApi
      .getSiteContractRequirementTypes()
      .then(function(response) {
        that.contractRequirementTypes = response.data;
      })
      .catch(function(error) {
        console.log(error);
      });

    sitesApi
      .getSite(this.siteId)
      .then(function(response) {
        that.site = response.data;
        that.site.description = htmlDecode(that.site.description);
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>

<style scoped>
</style>
